var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#006DC9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1452 -273) translate(352 239) translate(1101 34.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13,
    r: 12.5,
    strokeWidth: 1.087
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DC9",
    fillRule: "nonzero",
    strokeWidth: 0.6,
    d: "M9.923 18.78c.134.133.315.208.504.208s.37-.075.503-.208l4.838-4.834c.134-.134.209-.315.209-.503 0-.189-.075-.37-.209-.503L10.93 8.106c-.18-.18-.443-.25-.689-.183-.246.066-.438.26-.503.505-.065.247.006.509.186.689l4.335 4.33-4.335 4.332c-.133.133-.208.314-.208.503 0 .126.069.292.207.498z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseArrow);
export default __webpack_public_path__ + "static/media/collapse-arrow.361fda222b3d62031ea7ef3d31651a12.svg";
export { ForwardRef as ReactComponent };